import { render, staticRenderFns } from "./TheSupport.vue?vue&type=template&id=09039da2&scoped=true"
import script from "./TheSupport.vue?vue&type=script&lang=js"
export * from "./TheSupport.vue?vue&type=script&lang=js"
import style0 from "./TheSupport.vue?vue&type=style&index=0&id=09039da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09039da2",
  null
  
)

export default component.exports